import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FiUsers, FiTrendingUp, FiBarChart2, FiFileText } from 'react-icons/fi';
import AllHolders from './AllHolders';
import TopHolders from './TopHolders';
import HoldingsMovement from './HoldingsMovement';
import HolderDetail from './HolderDetail';
import MovementReportDetail from './MovementReportDetail';
import Reports from './Reports';

// url segment → tab; no segment = All holders. Reports' printable PDFs open headerless at /registry-report (ReportView.tsx).
// Top holders badge is fixed: the provider report is capped at 50 positions
const tabs = [
    { path: '', label: 'All holders', icon: <FiUsers />, component: AllHolders },
    { path: 'top-holders', label: 'Top holders', icon: <FiTrendingUp />, component: TopHolders, badge: 50 },
    { path: 'holdings-movement', label: 'Holdings movement', icon: <FiBarChart2 />, component: HoldingsMovement },
    { path: 'reports', label: 'Reports', icon: <FiFileText />, component: Reports },
];

const ShareRegistry: React.FC = () => {
    const history = useHistory();
    const { tab = '', id } = useParams<{ tab?: string; id?: string }>();
    // /share-registry/holder/{holderId} (or /holder/web?email=) opens a holder under the All holders tab
    const holder = tab === 'holder';
    // /share-registry/holdings-movement/{YYYY-MM-DD} opens that day's movement report under the Holdings movement tab
    const movementReport = tab === 'holdings-movement' && !!id;
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    return <div className="v2-page share-registry-v2">
        <div className="sub-tabs" data-tour="registry-tabs">
            {tabs.map(x => <button key={x.path} type="button" className={x === current ? 'active' : ''}
                onClick={() => history.push(`/share-registry${x.path && `/${x.path}`}`)}>{x.icon} {x.label}{x.badge && <span className="badge">{x.badge}</span>}</button>)}
        </div>

        {/* each tab renders its own .page-header — subtitle and actions differ per tab */}
        {holder ? <HolderDetail key={id} holderId={id} /> : movementReport ? <MovementReportDetail key={id} date={id!} /> : <current.component />}
    </div>;
};

export default ShareRegistry;
